import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd491a98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-tab" }
const _hoisted_2 = { class: "resume_contents_wrapper" }

import Desired from '@/components/Desired.vue';
import { ref } from 'vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';
import Loading from '@/components/Loading.vue';
import TabBar from '@/components/TabBar.vue';
import store from '@/store';

// パンくず

export default /*#__PURE__*/_defineComponent({
  __name: 'DesiredView',
  setup(__props) {

const breadcrumbs = [
  {
    label: 'ホーム',
    name: 'f00',
  },
  {
    label: '希望条件',
  },
];

const isLoading = ref(false);

const init = async () => {
  isLoading.value = true;
  try {
    await Promise.all([
      store.dispatch('careerSheetDesired/getDesiredCondition'),
      store.dispatch('master/getMasterDataListIndsctg'),
      store.dispatch('master/getMasterDataOcupClass'),
      store.dispatch('master/getMasterDataListEmpTypeBusicr'),
      store.dispatch('master/getMasterDataListPref'),
      store.dispatch('master/getMasterWishJobChangeDateId'),
      store.dispatch('userMenu/receive'),
    ]);
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(Breadcrumbs, { breadcrumbs: breadcrumbs }),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(TabBar, { isLink: "" }),
            _createVNode(Desired)
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})